import { render, staticRenderFns } from "./weeklyCalendar.vue?vue&type=template&id=7021bca6&scoped=true&"
import script from "./weeklyCalendar.vue?vue&type=script&lang=js&"
export * from "./weeklyCalendar.vue?vue&type=script&lang=js&"
import style0 from "./weeklyCalendar.vue?vue&type=style&index=0&id=7021bca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7021bca6",
  null
  
)

export default component.exports